// "A new version is ready" bar: the new service worker waits until the hiker chooses to update, so an update never
// reloads the app in the middle of a navigation or a recording (decisions.md PWA-26).

import { signal } from '@preact/signals';
import { t } from '../../i18n';
import { applyUpdate, onUpdateAvailable } from '../../sw/register';
import { useEnv } from '../env';

const updateReady = signal(false);
onUpdateAvailable(() => (updateReady.value = true));

export function UpdateBar() {
  const env = useEnv();
  if (!updateReady.value || env.liveActivity.value) return null;
  return (
    <div class="update-bar" role="status">
      <span class="spacer">{t('pwa.update.available')}</span>
      <button type="button" class="btn btn-plain" onClick={() => applyUpdate()}>
        {t('pwa.update.reload')}
      </button>
    </div>
  );
}
